import store from '@/store'
const liveshow = () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow')
const rawtail = () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/rawtail.vue')
const doublecode = () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/doublecode.vue')
const donot = () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/donot.vue')

const SelectAllupchChgoptions = () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/components/SelectAllupchChgoptions.vue')
const SelectAllupch = () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/components/SelectAllupch.vue')

const scode = {
  default: () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/scode.vue'),
  selectAllupch: SelectAllupchChgoptions
}
const rawcontact = {
  default: () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/rawcontact.vue'),
  selectAllupch: SelectAllupch
}
const tailcontact = {
  default: () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/tailcontact.vue'),
  selectAllupch: SelectAllupch
}
const other = {
  default: () => import(/* webpackChunkName: "liveshow" */ '@/views/liveshow/other.vue'),
  selectAllupch: SelectAllupch
}

const liveshowChildren = (pahtname) => [
  {
    path: 'scode',
    components: scode,
    name: `${pahtname}-scode`,
    meta: { title: '特码', page: '1', odd: { 1: '99', 2: '1', 3: '86' }, rightTable: true },
  },
  {
    path: 'pcode',
    components: scode,
    name: `${pahtname}-pcode`,
    meta: { title: '正码', page: '2', odd: "2", rightTable: true }
  },
  {
    path: 'pscode_1',
    components: scode,
    name: `${pahtname}-pscode_1`,
    meta: { title: '正1特', page: '3', odd: "3", rightTable: true }
  },
  {
    path: 'pscode_2',
    components: scode,
    name: `${pahtname}-pscode_2`,
    meta: { title: '正2特', page: '4', odd: "3", rightTable: true }
  },
  {
    path: 'pscode_3',
    components: scode,
    name: `${pahtname}-pscode_3`,
    meta: { title: '正3特', page: '5', odd: "3", rightTable: true }
  },
  {
    path: 'pscode_4',
    components: scode,
    name: `${pahtname}-pscode_4`,
    meta: { title: '正4特', page: '6', odd: "3", rightTable: true }
  },
  {
    path: 'pscode_5',
    components: scode,
    name: `${pahtname}-pscode_5`,
    meta: { title: '正5特', page: '7', odd: "3", rightTable: true }
  },
  {
    path: 'pscode_6',
    components: scode,
    name: `${pahtname}-pscode_6`,
    meta: { title: '正6特', page: '8', odd: "3", rightTable: true }
  },
  {
    path: 'rawtail',
    components: {
      default: rawtail,
      tool: () => import('@/views/liveshow/components/RadioAnimalNumber.vue'),
      selectAllupch: SelectAllupch
    },
    name: `${pahtname}-rawtail`,
    meta: { title: '生尾肖量', page: '9', odd: "11" },
  },
  {
    path: 'doublecode',
    components: {
      default: doublecode,
      tool: () => import('@/views/liveshow/components/SelectDobuecode.vue'),
      selectAllupch: SelectAllupchChgoptions
    },
    name: `${pahtname}-doublecode`,
    meta: { title: '连码', page: '10', odd: "9" }
  },
  {
    path: 'rawcontact',
    components: rawcontact,
    name: `${pahtname}-rawcontact`,
    meta: { title: '生连', page: '11', odd: "17" }
  },
  {
    path: 'tailcontact',
    components: tailcontact,
    name: `${pahtname}-tailcontact`,
    meta: { title: '尾连', page: '12', odd: "21" }
  },
  {
    path: 'donot',
    components: {
      default: donot,
      tool: () => import('@/views/liveshow/components/SelectDonotcode.vue'),
      selectAllupch: SelectAllupchChgoptions
    },
    name: `${pahtname}-donot`,
    meta: { title: '不中', page: '13', odd: "54" }
  },
  {
    path: 'selectonemore',
    components: {
      default: donot,
      tool: () => import('@/views/liveshow/components/SelectOnemorecode.vue'),
      selectAllupch: SelectAllupchChgoptions
    },
    name: `${pahtname}-selectonemore`,
    meta: { title: '多选中一', page: '14', odd: "60" }
  },
  {
    path: 'special',
    components: {
      default: donot,
      tool: () => import('@/views/liveshow/components/SelectSpecialcode.vue'),
      selectAllupch: SelectAllupchChgoptions
    },
    name: `${pahtname}-special`,
    meta: { title: '特平中', page: '15', odd: "66" }
  },
  {
    path: 'other',
    components: other,
    name: `${pahtname}-other`,
    meta: { title: '其他', page: '16', odd: "65", pid3: "80" }
  }
]

export const liveshowAllLeading = {
  path: `liveshowAll`,
  name: 'liveshowAll',
  meta: { title: '现场监督(各站点)' },
  component: liveshow,
  redirect: to => {
    return {
      name: `liveshowAll-scode`,
    }
  },
  beforeEnter: (to, from, next) => {
    if (store.getters.getpermission.inspect[0] != '1') return next({ name: 'no-permission', params: to.params })
    next()
  },
  children: liveshowChildren('liveshowAll')
}
export const liveshowLeading = {
  path: `liveshow`,
  name: 'liveshow',
  meta: { title: '現場監督(高管)' },
  component: liveshow,
  redirect: to => {
    return {
      name: `liveshow-scode`,
    }
  },
  beforeEnter: (to, from, next) => {
    if (store.getters.getpermission.inspect[0] != '1') return next({ name: 'no-permission', params: to.params })
    next()
  },
  children: liveshowChildren('liveshow')
}

